<template>
  <div class="vx-row">
    <vx-card>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <vs-button icon="keyboard_backspace" @click="goBack">Back</vs-button>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">
          <h3>Opportunities</h3>
        </vs-col>
        <vs-col vs-type="flex" vs-lg="4" vs-sm="4" vs-xs="12">

          <vs-button size="small" type="flat" @click="saveViewPopup">Save View</vs-button>

          <span class="mt-3 mr-5 ml-5">Select:</span>

            <v-select style="width:50%" v-model="selected_view_for_sd" label="name" :options="sd_view_options"
              name="sd_view" />
        </vs-col>
      </vs-row>

      <DataGrid :context="'SDOpportunities'" @goToEditSalesDeveloperOpportunities="goToEditSalesDeveloperOpportunities" ref="SDOpportunities"
        :columnDefs="columnDefs" :rowData="records" :dataSource="dataSource">
      </DataGrid>



      <vs-popup title="Update Opportunity" fullscreen :active.sync="showSDOpportunitiesPopUp">
        <vs-row>

          <vs-row>
            <div
              class="vx-col w-full p-2"
              v-for="field in opportunity_field_options"
              
            >
  
  
  
  
              <div
                class="vx-row p-5"
                v-if="field.field_type == 'opportunity_field'"
              >
                <div class="vx-col sm:w-1/5 w-full">
                  <h6>{{ field.name }} </h6>
                </div>
  
               
  
                <div class="vx-col sm:w-2/3 w-full">
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'text'"
                  >
                    <vs-input
                      class="w-full"
                      v-model="
                        opportunity_field_datas[field.column_id].value
                      "
                      name="name"
                    />
                  </div>
  
                  <div
                  class="vx-col sm:w-1/3 w-full"
                  v-if="field.type == 'client_contact'"
                >
                  <div class="auto_search_container">
                    <input
                      class="autocom"
                      type="text"
                      v-model="search"
                      @blur="toggle = false"
                      @focus="toggle = true"
                    />
                    <div class="results" v-if="toggle">
                      <div
                        class="result"
                        v-for="client_contact in newCampaignClientContacts"
                      >
                        <span
                          @click="selectResult(client_contact , field.column_id)"
                          @mousedown.prevent
                        >
                          {{ client_contact.full_name }}
                        </span>
                        
                      </div>

                    </div>

                    {{ typeof opportunity_field_datas[field.column_id].value === 'string'  ? JSON.parse(opportunity_field_datas[field.column_id].value).full_name : '' }}


                  </div>

                </div>

                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'number'"
                  >
                    <vs-input
                      class="w-full"
                      v-model="
                        opportunity_field_datas[field.column_id].value
                      "
                      name="name"
                      type="number"
                    />
                  </div>
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'textarea'"
                  >

                  <vue-trumbowyg v-model="opportunity_field_datas[field.column_id].value" 
                  :config="configs.basic"></vue-trumbowyg>


                  
                  </div>
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'date'"
                  >
                    <flat-pickr
                      v-model="
                        opportunity_field_datas[field.column_id].value
                      "
                      :config="configDateTimePicker"
                      placeholder="Choose Date"
                      name="continuous_date_end"
                    />
                  </div>

                    <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'datetime'"
                  >
                    <flat-pickr
                      v-model="
                        opportunity_field_datas[field.column_id].value
                      "
                      :config="configDateAndTimePicker"
                      placeholder="Choose Date And Time"
                      name="continuous_date_and_time"
                    />
                  </div>
  
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'checkbox'"
                  >
                    <span v-for="v in JSON.parse(field.values)" class="p-2">
                      <input
                        :key="componentKey"
                        type="checkbox"
                        class="mr-2"
                        :value="v.value"
                        :id="
                          opportunity_field_datas[field.column_id].model
                        "
                        :checked="
                          opportunity_field_datas[field.column_id].value !=
                            null &&
                          opportunity_field_datas[
                            field.column_id
                          ].value.includes(v.value)
                        "
                        @click="checkOpportunitySelectedCheckboxField($event)"
                      />
                      {{ v.value }}
                    </span>
                  </div>
  
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'dropdown'"
                  >
                    <v-select
                      v-model="
                        opportunity_field_datas[field.column_id].value
                      "
                      label="value"
                      :options="JSON.parse(field.values)"
                      name="type"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </div>
  
                  <div
                    class="vx-col sm:w-1/3 w-full"
                    v-if="field.type == 'choose_one'"
                  >
                    <span v-for="v in JSON.parse(field.values)" class="p-2">
                      <vs-radio
                        :vs-name="field.field"
                        :vs-value="v.value"
                        class="mr-2"
                        v-model="
                          opportunity_field_datas[field.column_id].value
                        "
                        >{{ v.value }}</vs-radio
                      >
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="vx-row w-full p-5">
              <div class="vx-col sm:w-1/5 w-full"></div>
              
            </div>
          </vs-row>


       
          <div class="vx-row w-full p-5">
            <div class="vx-col sm:w-1/5 w-full">
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <vs-button class="ml-3" @click.prevent="updateOpportunity">Update</vs-button>
            </div>
          </div>
        </vs-row>
      </vs-popup>

      <vs-popup title="Save View" :active.sync="showHideSaveViewPopUp">
        <vs-row>
          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full">
              <div class="vx-col sm:w-1/4 w-full">
                <h6>Name:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-input class="w-full" v-model="save_view_name" name="name" />
                <span class="text-danger text-sm">{{ please_choose_save_view_name }}</span>

              </div>
            </div>
          </vs-col>

          <vs-col vs-type="flex" vs-w="12">
            <div class="vx-row w-full mt-5">
              <div class="vx-col sm:w-1/4 w-full">
                <h6>Description:</h6>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <vs-textarea class="w-full" name="save_view_description" v-model="save_view_description" />

                <vs-button class="mt-5" @click.prevent="submitSaveViewAction">Submit</vs-button>
              </div>
            </div>
          </vs-col>

        </vs-row>
      </vs-popup>


    </vx-card>
  </div>
</template>

<script>


var OppOwnerValueFormatter = function(params) {




  if(params.value){


    params.value = JSON.parse(params.value)


      if (params.value.hasOwnProperty('full_name')){
      return params.value.full_name

    }


  


  }
};

import DataGrid from "@/components/aggrid/Aggrid.vue";
import defineAbilitiesFor from "@/config/abilities";
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from "moment";

import VueTrumbowyg  from 'vue-trumbowyg';
import 'jquery-resizable-dom/dist/jquery-resizable.js';
import 'jquery-resizable-dom/dist/jquery-resizableTableColumns.js';

import 'trumbowyg/dist/trumbowyg.min.js';
import 'trumbowyg/dist/ui/trumbowyg.min.css';
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css';
import 'trumbowyg/dist/plugins/table/trumbowyg.table.min.js';
import 'trumbowyg/dist/plugins/table/ui/trumbowyg.table.min.css';
import 'trumbowyg/dist/plugins/fontsize/trumbowyg.fontsize.min.js';
import 'trumbowyg/dist/plugins/upload/trumbowyg.upload.min.js';
import 'trumbowyg/dist/plugins/colors/trumbowyg.colors.min.js'
import 'trumbowyg/dist/plugins/colors/ui/trumbowyg.colors.min.css'
import 'trumbowyg/dist/plugins/pasteimage/trumbowyg.pasteimage.min.js'
import 'trumbowyg/dist/plugins/preformatted/trumbowyg.preformatted.min.js'
import 'trumbowyg/dist/plugins/lineheight/trumbowyg.lineheight.min.js'
import 'trumbowyg/dist/plugins/indent/trumbowyg.indent.min.js'
import 'trumbowyg/dist/plugins/resizimg/trumbowyg.resizimg.js'

export default {
  data: () => ({
    configs: {
          basic: {
            autogrow: true,
            removeformatPasted: true,
                btns: [
                    ['strong', 'em'],
                    ['superscript', 'subscript'],
                    ['fontsize'],
                    ['foreColor', 'backColor'],
                    ['link'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['horizontalRule'],
                    ['removeformat'],
                    ['fullscreen']
                ],
                plugins: {
                    table: {
                        columns: 10,
                        rows: 10,
                    
                    },
                    resizimg: {
            minSize: 64,
            step: 16,
        }

                    }
                        }
      },
    opportunitiesCheckedFields: {},
    componentKey: 0,
    search: '',
    toggle: false,
    campaign_client_contacts: [],
    newCampaignClientContacts: [],
    newCampaignClientContacts: [],
    selected_view_for_sd: null,
    sd_view_options: [],
    showHideSaveViewPopUp: false,
    please_choose_save_view_name: null,
    save_view_name: null,
    save_view_description: null,
    sd_view_options: [],
    // checkedValues:['Ipad' , 'Laptop' ],
    configDateTimePicker: {
      enableTime: false,
      dateFormat: "Y-m-d"
    },
    configDateAndTimePicker: {
      enableTime: true,
      dateFormat: "Y-m-d H:i:s",
      enableSeconds : true
    },
    showSDOpportunitiesPopUp: false,
    closeshowSDOpportunitiesPopUp: false,
    opportunity_field_options: [],
    opportunity_field_datas: [],
    abilities: null,
    columnDefs: [
    ],
    dataSource: {},
    records: [],
    showHideSaveViewPopUp: false,
  }),
  components: {
    "v-select": vSelect,
    moduleCampaignManagement,
    DataGrid,
    flatPickr,
    VueTrumbowyg

  },
  watch: {
    search(val) {
      let self = this
      self.newCampaignClientContacts = [];

      self.campaign_client_contacts.forEach(element => {
        if (element.full_name.includes(val) && val != "") {
          self.newCampaignClientContacts.push(element);
        }
      });

       const key = 'user_id';

self.newCampaignClientContacts = [...new Map(self.newCampaignClientContacts.map(item =>
[item[key], item])).values()];

    },
    selected_view_for_sd(val) {
      const opportunities_saved_state = JSON.parse(val.opportunities_view);
      this.$refs.SDOpportunities.gridApi.applyColumnState({ state: opportunities_saved_state, applyOrder: true });

      const opportunities_filter_saved_state = JSON.parse(val.opportunities_filter);
      this.$refs.SDOpportunities.gridApi.setFilterModel(opportunities_filter_saved_state)
    },
  },
  methods: {
    selectResult (client_contact , column_id) {
      let self = this
      self.search = client_contact.full_name

      let dataObj = {}
      dataObj.full_name = client_contact.full_name
      dataObj.id = client_contact.uuid

      for (const property in self.opportunity_field_datas) {
        self.opportunity_field_datas[column_id].value = dataObj
      }

      // console.log("SLEEE res" , self.opportunity_field_datas)
    },
    submitSaveViewAction() {
      let self = this
      let data = {}
      data.name = self.save_view_name;
      data.description = self.save_view_description;
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = self.user_id;
      data.user_type = 'sales_developer';
      data.opportunities_view = this.$refs.SDOpportunities.gridApi.getColumnState()
      data.opportunities_filter = this.$refs.SDOpportunities.gridApi.getFilterModel();
      if (self.save_view_name != null) {
        self.$store
          .dispatch("campaignsManagement/saveSDOpportunitiesSavedView", data)
          .then(res => {
            if (res) {
              if (res.data.status == "success") {
                self.$refs.SDOpportunities.gridApi.refreshServerSide({purge : true});
                self.getDataSource();
                self.showHideSaveViewPopUp = false;
                self.selected_status = null;
                self.getOpportunitiesSavedViewLists()
              }
            }
          })
          .catch(err => {
            console.log(err);
          });
      }


    },
    checkOpportunitySelectedCheckboxField (e) {
      let self = this

      this.$nextTick(() => {
        for (const property in self.opportunitiesCheckedFields) {
          if (e.target.id === property) {
            if (self.opportunitiesCheckedFields[property] != null) {
              if (
                self.opportunitiesCheckedFields[property].includes(
                  e.target.value
                )
              ) {
                self.opportunitiesCheckedFields[property] =
                  self.opportunitiesCheckedFields[property].filter(function (
                    ele
                  ) {
                    return ele !== e.target.value
                  })
              } else {
                // alert(e.target.value)
                self.opportunitiesCheckedFields[property].push(e.target.value)
                // console.log(self.opportunitiesCheckedFields[property])

                if (self.opportunitiesCheckedFields[property].length != 0) {
                  self.opportunitiesCheckedFields[property] =
                    self.opportunitiesCheckedFields[property].filter(
                      x => x != null
                    )
                }
              }
            } else {
              self.opportunitiesCheckedFields[property] = []
              self.opportunitiesCheckedFields[property].push(e.target.value)

              if (self.opportunitiesCheckedFields[property].length != 0) {
                self.opportunitiesCheckedFields[property] =
                  self.opportunitiesCheckedFields[property].filter(
                    x => x != null
                  )
              }
            }
          }
        }
        return false
      })



    },
    saveViewPopup() {
      this.showHideSaveViewPopUp = true
      // console.log("Account COLUMNSTATE" , this.$refs.SDQCAccount.gridApi.getColumnState())

      // console.log("Contact COLUMNSTATE" , this.$refs.SDQCContact.gridApi.getColumnState())


    },
    getOpportunitiesSavedViewLists() {
      let self = this
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      data.user_id = self.user_id;
      self.$store
        .dispatch("campaignsManagement/getOpportunitiesSavedViewLists", data)
        .then(res => {
          if (res) {
            self.sd_view_options = res.data;
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    updateOpportunity() {
      let self = this;
      self.opportunity_field_datas.checkbox_columns = self.opportunitiesCheckedFields
      this.$store
        .dispatch("campaignsManagement/updateSDCreatedOpportunity", self.opportunity_field_datas)
        .then(res => {
          if (res.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Opportunity",
              text: res.data.message
            });

            
            this.$router.go(0)
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    getSelectedOpportunityFieldsWithDetails(db_value) {
      let self = this;
      let data = {}
      data.campaign_id = this.$route.params.campaignId;
      self.opportunitiesCheckedFields = {}
      self.$store
        .dispatch(
          "campaignsManagement/getSelectedOpportunityFieldsWithDetails",
          data
        )
        .then(res => {

          if (res.data) {
            let result = JSON.parse(res.data)
            self.opportunity_field_options = result[0]['options']
            self.opportunity_field_datas = result[0]['data']
            let new_opportunity_field_values = {}
            self.opportunity_field_options.forEach(function (ele) {
              Object.entries(self.opportunity_field_datas).forEach(
                ([key, value]) => {
                  if (key == ele.column_id) {
                    let json_value = null

                    try {
                      json_value = JSON.parse(value)
                    } catch (e) {
                      json_value = value
                    }

                    if (json_value != null) {
                      if (json_value.length == 1) {
                        json_value = json_value[0]
                      }

                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    } else {
                      new_opportunity_field_values[key] = {
                        value: json_value,
                        type: ele.type,
                        options: ele.values,
                        model: key
                      }
                    }
                  }
                }
              )
            })

            self.opportunity_field_datas = new_opportunity_field_values

            for (const property in self.opportunity_field_datas) {


              for (const db_value_property in db_value) {
                if (db_value_property == property) {
                  self.opportunity_field_datas[property].value = db_value[db_value_property]
                }

              }


              if (self.opportunity_field_datas[property].type == 'checkbox') {
                if (self.opportunity_field_datas[property].value != null) {
                  self.opportunitiesCheckedFields[property] = self.opportunity_field_datas[property].value.split(",")

                }else{
                  self.opportunitiesCheckedFields[property] = []
                }
              }
            }



            self.opportunity_field_datas['campaign_id'] = db_value.campaign_id
            self.opportunity_field_datas['sd_opportunity_id'] = db_value.sd_opportunity_id
            self.opportunity_field_datas['id'] = db_value.id
            self.opportunity_field_datas['account_id'] = db_value.account_id
            self.opportunity_field_datas['contact_id'] = db_value.contact_id
            self.opportunity_field_datas['sales_developer_id'] = db_value.sales_developer_id

          }


        })
        .catch(err => {
          console.log(err)
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    getSDOpportunitiesColumns() {
      var self = this;
      self.$store
        .dispatch(
          "campaignsManagement/getSDOpportunitiesColumns",
          self.$route.params.campaignId
        )
        .then(res => {
            let selected_columns = JSON.parse(res.data);



              selected_columns = selected_columns.filter(function(ele) {
                return ele.identifier != 'phone_code' && ele.identifier != 'phone_type' && ele.identifier != 'switchboard_phone_code' 
              });


              var index = 1;
            selected_columns.forEach(function(ele) {
              ele.id = ele.uuid
              ele.field = '_' + ele.id.replaceAll('-', '_');
              ele.headerName = ele.name;

              if (ele.type == "textarea") {
                ele.cellRenderer =  function(params) {
                            return params.value ? params.value : '';
                        }
              }

         
                if (ele.type == "date" || ele.type == "datetime") {
                  ele.filter = "agDateColumnFilter";
                } else if (ele.type == "number") {
                  ele.filter = "agNumberColumnFilter";
                } else if (ele.type == "client_contact") {
                  ele.valueFormatter = OppOwnerValueFormatter
                  ele.filter = "agTextColumnFilter";
                } else {
                  ele.filter = "agTextColumnFilter";
                }



              ele.width = 170;
              ele.filterParams = {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              };
            });


          self.columnDefs = selected_columns

          let company_name = {
            headerName: 'Company Name',
            field: 'company_name',
            filter : "agTextColumnFilter",
            flex: 1,
            filterParams : {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              }
          }

          self.columnDefs.push(company_name);

          let contact_full_name = {
            headerName: 'Contact',
            field: 'contact_full_name',
            filter : "agTextColumnFilter",
            flex: 1,
            filterParams : {
                buttons: ["apply", "reset"],
                maxNumConditions: 4
              }
          }

          self.columnDefs.push(contact_full_name);



          let actions = {
            headerName: 'Actions',
            sortable: false,

            field: 'transactions',
            cellRenderer: 'CellRendererActions',
            suppressHeaderMenuButton: true,
            pinned: true,
            width: 110
          }

          self.columnDefs.push(actions);



        })
        .catch(err => {
          console.log(err);
        });
    },
    goToEditSalesDeveloperOpportunities(value) {
      var self = this;
      self.getSelectedOpportunityFieldsWithDetails(value)
      // self.opportunity_field_datas = value

      // console.log("VALUE", value)



      self.showSDOpportunitiesPopUp = true;
      // this.showPopulateDataPopUp = true;
      // alert(value)
    },
    fetchCampaignAssociatedClientContact() {
      let self = this;
      this.$store
        .dispatch(
          "elomarkUsersManagement/fetchCampaignAssociatedClientContact",
          this.$route.params.campaignId
        )
        .then(res => {
          self.campaign_client_contacts =
            moduleElomarkUserManagement.state.campaign_associated_client_contact;
          self.campaign_client_contacts.map(function (ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
          });


        })
        .catch(err => {
          console.log(err);

        });
    },
    getDataSource() {
      var self = this;
      this.dataSource = {
        getRows(params) {
          params.request.sales_developer_id = self.$route.params.sd_user_id
          params.request.selected_campaign_id = self.$route.params.campaignId
          self.$store
            .dispatch(
              "campaignsManagement/getSDOpportunities",
              params.request
            )
            .then(function (response) {
              let response_data = response.rows;





              response_data.forEach(function (el) {

                Object.keys(el).forEach((key) => {

                  if (key == 'created_at') {
                    el[key] = moment(el[key]).format('YYYY-MM-DD HH:mm:ss')
                  }


               

                  else if (typeof el[key] === 'string' || el[key] instanceof String) {


                    if (el[key].startsWith('[') && el[key] != '[]') {
                      

                      try {
                        el[key] = JSON.parse(el[key])
                      } catch (e) {
                        el[key] = el[key]
                      }



                      el[key] = el[key].toString()

                    }


                    // if (el[key].startsWith('{')) {
                    //   el[key] = JSON.parse(el[key])

                    //   if (el[key].hasOwnProperty('full_name')) {
                    //     el[key] = el[key]['full_name']
                    //   }
                    // }





                  }













                });

              })

              if (response_data.length != 0) {
                self.$refs.SDOpportunities.gridApi.sizeColumnsToFit();
                self.$refs.SDOpportunities.gridApi.hideOverlay();
                params.success({ rowData: response.rows , rowCount: response.lastRow })
              } else {
                self.$refs.SDOpportunities.gridApi.showNoRowsOverlay();
                return params.success({ rowData: [] })
              }
            })
            .catch(err => {
              console.error(err);
            });
        }
      };
    },
    goBack: function () {
      this.$router.go(-1);
    }
  },
  beforeMount() {
    // this.getDataSource();
  },
  mounted() {
    this.fetchCampaignAssociatedClientContact()
    this.getDataSource();
    this.getSDOpportunitiesColumns();
   this.getOpportunitiesSavedViewLists()

  },
  created() {

    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];

    if (this.user_role != 'Sales Developer') {
      this.$router.replace("/unauthorized")
    }

    var self = this;
    defineAbilitiesFor().then(function (data) {
      self.abilities = data;
    });
    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }

    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.filter {
  width: 300px;
}

.pointer {
  cursor: pointer;
}

.item.expanded {
  background-color: white !important;
  color: black !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  background: none !important;
  box-shadow: none !important;
}

.tr-table-state-primary,
.vs-table-primary .is-selected {
  color: #626262 !important;
  -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
  box-shadow: 0 0 1px 0 rgba(var(--vs-primary), 1) !important;
}

.pointer {
  cursor: pointer;
}

.address_th {
  padding: 30px;
}

.address_td {
  padding: 30px;
  font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-Tags
  .con-btns-Tags
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-Tagsx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
